var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29 4.625a3 3 0 0 0-3 3v1.5h21v-1.5a3 3 0 0 0-3-3h-15zM2.29 16.625v-6h21v6a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3zm14.25-1.5a.75.75 0 0 0 0 1.5h3a.75.75 0 1 0 0-1.5h-3z",
    fill: "#8199B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCardIcon);
export default __webpack_public_path__ + "static/media/Input-Card-Icon.91366e78b639e09d5bacd3befb5be4a8.svg";
export { ForwardRef as ReactComponent };